import { createClient } from '@supabase/supabase-js';
import { env } from './env';

// One client for the whole app. Every table is behind RLS, so the anon key can
// only ever read what the signed-in person is allowed to read.
export const supabase = createClient(env.supabaseUrl, env.supabaseAnonKey, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
});
